import { BannerTypeEnum } from 'api/enums';
import { IAnnouncementBannerModel } from 'api/models';
import { InfoCircleIcon } from 'library/icons';
import { useEffect, useMemo, useRef, useState } from 'react';

const AnnouncementBanner = (props: Pick<IAnnouncementBannerModel, 'type' | 'message'>) => {
    const { type, message } = props;

    const textRef = useRef<HTMLDivElement>(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    const options = useMemo(() => {
        let bgClassWithTransparency = '';
        let textClass = '';

        switch (type) {
            case BannerTypeEnum.SUCCESS:
                bgClassWithTransparency = 'bg-success-100';
                textClass = 'text-success-500';
                break;
            case BannerTypeEnum.WARNING:
                bgClassWithTransparency = 'bg-warning-100';
                textClass = 'text-warning-500';
                break;
            case BannerTypeEnum.ERROR:
                bgClassWithTransparency = 'bg-danger-100';
                textClass = 'text-danger-500';
                break;
            case BannerTypeEnum.INFO:
                bgClassWithTransparency = 'bg-grayscale-100';
                textClass = 'text-grayscale-500';
                break;
        }

        return {
            bgClassWithTransparency,
            textClass,
        };
    }, [type]);

    useEffect(() => {
        const checkOverflow = () => {
            const el = textRef.current;
            if (el) {
                setIsOverflowing(el.scrollWidth > el.clientWidth);
            }
        };

        checkOverflow();
        window.addEventListener('resize', checkOverflow);
        return () => window.removeEventListener('resize', checkOverflow);
    }, [message]);

    return (
        <div className={['flex items-center gap-3 py-2 px-6', options.bgClassWithTransparency].join(' ')}>
            <InfoCircleIcon className={[options.textClass].join(' ')} />

            {isOverflowing ? (
                <div className="marquee flex-1 overflow-hidden">
                    <div ref={textRef} className="text-xs font-medium text-[#101828] whitespace-nowrap">
                        {message}
                    </div>
                </div>
            ) : (
                <div ref={textRef} className="text-xs font-medium text-[#101828] flex-1 truncate">
                    {message}
                </div>
            )}
        </div>
    );
};

export default AnnouncementBanner;
